import * as types from "./types";

import KnownOriginResult from "../../../domains/Origins/KnownOriginResult";

export function getOriginStatus() {
  return {
    type: types.GET_ORIGIN_STATUS,
    payload: {
      isFetchingOrigin: true
    }
  };
}

export function getOriginStatusSuccess(
  originStatus: Array<KnownOriginResult>,
) {
  return {
    type: types.GET_ORIGIN_STATUS_SUCCESS,
    payload: {
      isFetchingOrigin: false,
      originStatus
    },
  };
}
export function getOriginStatusError() {
  return {
    type: types.GET_ORIGIN_STATUS_ERROR,
    payload: {
      isFetchingOrigin: false,
      hasError: true
    },
  };
}